import { render, staticRenderFns } from "./DiscountFormula.vue?vue&type=template&id=3293b698&"
import script from "./DiscountFormula.vue?vue&type=script&lang=ts&"
export * from "./DiscountFormula.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports